import "../script/main";
import "../scss/index.scss";
